export const PERSONALIZED_PLAN_STATUS_FORBIDDEN_FALLBACK =
  "You don't have permission to change the status of this Personalized Plan.";

type ApiErrorLike = {
  status?: number;
  error?: {
    detail?: unknown;
  };
};

export function getPersonalizedPlanStatusErrorMessage(error: unknown): string | null {
  const apiError = error as ApiErrorLike | null | undefined;

  if (apiError?.status !== 403) {
    return null;
  }

  const detail = apiError?.error?.detail;

  return typeof detail === 'string' && detail.trim()
    ? detail
    : PERSONALIZED_PLAN_STATUS_FORBIDDEN_FALLBACK;
}
